import React, { useEffect, useState } from "react";
import { Grid, Container } from "@mui/material";
import DeliveryHead from "../DeliveryHead";
import Clothesbox from "../../../../assets/images/Clothesbox.png";
import calendar from "../../../../assets/images/calendar.png";
import recordcircle from "../../../../assets/images/record-circle.png";
import location from "../../../../assets/images/location.png";
import comment from "../../../../assets/images/comment.png";
import camera from "../../../../assets/images/camera.png";
// import orderimg from "../../../../assets/images/orderimg.png";
import MainButton from "../../../shared/Button";
import order_preview_mobile from "../../../../assets/images/order-preview_mobile.png";
import { useNavigate } from "react-router-dom";
import {
  QuoteApprovedMain,
  PreviewOrderHeader,
  QuoteItem,
  ButtonMain,
} from "../styles/QuoPreviewOrderStyle";
import { ORDERS } from "../../../../constants/apiEndPoints";
import httpRequest from "../../../../axios/index";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import { truncateText } from "../../../../helpers/truncateText";
import Loader from "../../../shared/loader";
// import { getLocationName } from "../../../../helpers/getLocationName";
import { formatDateTime } from "../../../../helpers/DateFormate";
import Tooltip from "@mui/material/Tooltip";

const QuoPreviewOrder = ({ NavigateCallback }) => {
  const [OrderData, SetOrderData] = useState([]);
  // const [PickUpAddress, SetPickUpAddress] = useState();
  // const [DropoffAddress, SetDropoffAddress] = useState();
  const [Loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  useEffect(() => {
    if (id) {
      GetAllOrders();
    } else {
      toast.error("Invalid ID");
    }
  }, [id]);

  const GetAllOrders = async () => {
    try {
      setLoading(true);
      const resp = await httpRequest.get(`${ORDERS}/${id}`);
      if (resp?.status === 200) {
        if (resp?.data.message === "Success") {
          SetOrderData(resp?.data?.data);
        }
      }
      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      setLoading(false);
    }
  };

  const navigate = useNavigate();
  const ShowPreviusPage = () => {
    NavigateCallback(false);
  };

  // useEffect(() => {
  //   if (OrderData && OrderData.stops && OrderData.stops.length > 0) {
  //     // get the pickupp accress
  //     if (OrderData?.stops[0]?.location) {
  //       const fetchLocationNames = async () => {
  //         const locationName = await getLocationName(
  //           OrderData?.stops[0]?.location?.latitude,
  //           OrderData?.stops[0]?.location?.longitude
  //         );
  //         SetPickUpAddress(locationName);
  //         // console.log(
  //         //   `Location Name (${OrderData?.stops[0]?.location?.latitude}, ${OrderData?.stops[0]?.location?.longitude}):`,
  //         //   locationName
  //         // );
  //       };
  //       fetchLocationNames();
  //     }
  //     // get the dropoff name
  //     if (OrderData?.stops[1]?.location) {
  //       const fetchLocationNames = async () => {
  //         const locationName = await getLocationName(
  //           OrderData?.stops[1]?.location?.latitude,
  //           OrderData?.stops[1]?.location?.longitude
  //         );

  //         // console.log(
  //         //   `Location Name (${OrderData?.stops[1]?.location?.latitude}, ${OrderData?.stops[1]?.location?.longitude}):`,
  //         //   locationName
  //         // );
  //         SetDropoffAddress(locationName);
  //       };
  //       fetchLocationNames();
  //     }
  //   }
  // }, [OrderData]);

  return (
    <>
      <DeliveryHead
        Value={50}
        BackLink="/quot-order-details"
        CenterText="Preview Order"
        StepText="2 of 4"
        showBox={false}
        showLink={false}
        haveCallBack={true}
        CallBackFun={ShowPreviusPage}
      />
      <QuoteApprovedMain>
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12} md={10} lg={7}>
              <PreviewOrderHeader>
                <img src={order_preview_mobile} alt="order_preview_mobile" />
                <h6>Your request has been sent.</h6>
                <p>You’ll receive offers shortly.</p>
              </PreviewOrderHeader>
              <QuoteItem>
                {Loading && <Loader />}
                {!Loading &&
                  OrderData &&
                  OrderData.stops &&
                  OrderData.stops.length > 0 && (
                    <>
                      <div className="Quote_ItemMain">
                        <img src={Clothesbox} alt="Clothesbox" />
                        <span>
                          {OrderData.stops[0]?.order_detail?.name || ""}
                        </span>
                      </div>
                      <div className="date_ItemMain">
                        <img src={calendar} alt="Clothesbox" />
                        <span>
                          {OrderData.stops[0]?.order_detail?.datetime &&
                            formatDateTime(
                              OrderData.stops[0]?.order_detail?.datetime
                            )}
                        </span>
                      </div>
                      <div className="pickup_ItemMain">
                        <img src={recordcircle} alt="Clothesbox" />
                        {/* <span> {PickUpAddress} </span> */}
                        <Tooltip
                          title={OrderData?.stops[0]?.location?.address}
                          arrow
                        >
                          <span>{OrderData?.stops[0]?.location?.address} </span>
                        </Tooltip>
                      </div>
                      <div className="drop_ItemMain">
                        <img src={location} alt="Clothesbox" />
                        <Tooltip
                          title={OrderData?.stops[1]?.location?.address}
                          arrow
                        >
                          <span>{OrderData?.stops[1]?.location?.address} </span>
                        </Tooltip>
                      </div>
                      <div className="many_orders">
                        <img src={comment} alt="Clothesbox" />
                        <span>
                          {truncateText(
                            OrderData.stops[0]?.order_detail?.description || "",
                            30
                          )}
                        </span>
                      </div>
                      <div className="orders_image">
                        <img src={camera} alt="comment" />
                        <div className="orders_image_items">
                          {OrderData.stops[0]?.order_detail?.image_urls &&
                            OrderData.stops[0]?.order_detail?.image_urls.map(
                              (values) => {
                                return (
                                  <img
                                    src={values?.url}
                                    alt={OrderData.stops[0]?.order_detail?.name}
                                    className="orderImg"
                                    key={values?.id}
                                  />
                                );
                              }
                            )}
                        </div>

                        {/* {OrderData.stops[0]?.order_detail?.image_urls &&
                          OrderData.stops[0]?.order_detail?.image_urls.length >
                            2 && (
                            <span className="more-text">
                              {OrderData.stops[0]?.order_detail?.image_urls
                                .length - 2}{" "}
                              more
                            </span>
                          )} */}
                      </div>
                    </>
                  )}
              </QuoteItem>
              <ButtonMain>
                <MainButton
                  type="button"
                  label="Cancel Order"
                  border={true}
                  onClick={() => navigate("/delivery-home")}
                />
                <MainButton
                  type="button"
                  label="Back to Home"
                  onClick={() => navigate("/delivery-home")}
                />
              </ButtonMain>
            </Grid>
          </Grid>
        </Container>
      </QuoteApprovedMain>
    </>
  );
};

export default QuoPreviewOrder;
